<script>
import PrizeChampCard from "@/components/2025/Prizes/PrizeChampCard.vue";
export default {
  components: {
    PrizePlaceCard: PrizeChampCard
  },
  name: "ChampionCard",
  props: ['champsItem', "game"]
}
</script>

<template>
  <div class="champion-card-wrapper w-100 h-100">
    <div class="">
      <img class="w-100" width="100%" height="230px"
           :src="champsItem.img" alt="" />
    </div>
    <div class="pr-2">
      <PrizePlaceCard place="first" :item="champsItem.first" :prize-amount="champsItem.first.prize"></PrizePlaceCard>
      <PrizePlaceCard place="second" :item="champsItem.second" :prize-amount="champsItem.second.prize"></PrizePlaceCard>
      <PrizePlaceCard place="third" :item="champsItem.third" :prize-amount="champsItem.third.prize"></PrizePlaceCard>
    </div>
    <div class="game-name-container">
      <p class="game-name text-white m-0 text-uppercase px-2 py-1">{{champsItem.game}}</p>
    </div>

  </div>

</template>

<style scoped>
.champion-card-wrapper {
  background: rgba(18, 18, 18, 1);
  clip-path: polygon(0 0, 100% 0, 100% calc(100% - 16px), calc(100% - 16px) 100%, 0 100%);
  border-radius: 0 4px 20px 4px;
}
img{
  object-fit: cover;
  object-position: top center;
  clip-path: polygon(0 0, 100% 0, 100% calc(100% - 16px), calc(100% - 16px) 100%, 0 100%);
  border-radius: 0 4px 20px 0px;
}
.game-name-container {
  border-top: 2px solid black;
  background: rgba(250, 70, 36, 0.15);
  background: linear-gradient(-15deg,rgba(250, 70, 36, 0.06) 0%, rgba(250, 70, 36, 0.04) 15%, rgba(250, 70, 36, 0) 100%);
}
.game-name{
  font-family: "sqwaredsemi_bold";
  color: rgba(255,255,255,0.2) !important;
}
</style>